import { defineComponent as l, openBlock as t, createBlock as o, normalizeProps as r, guardReactiveProps as c, withCtx as n, renderSlot as p, createElementVNode as m } from "vue";
import s from "../CdrIcon.vue.mjs";
const i = /* @__PURE__ */ m("path", {
  role: "presentation",
  d: "M7.125 8.986a1.865 1.865 0 01-1.863-1.864 1.865 1.865 0 013.117-1.378.374.374 0 01-.195.7h-.01a.68.68 0 10-.006 1.358.38.38 0 01.351.231.37.37 0 01-.078.408 1.85 1.85 0 01-1.316.545zm0-2.977c-.614 0-1.113.5-1.113 1.113 0 .66.609 1.184 1.252 1.105a1.427 1.427 0 01-.002-2.21 1.196 1.196 0 00-.137-.008zm11.533 11.343a.376.376 0 01-.012.531l-.68.65a.372.372 0 01-.33.204h-12a.368.368 0 01-.307-.173l-.713-.68a.375.375 0 11.518-.543l.158.15c.352-3.935 3.056-7.008 6.334-7.016h.012c1.006.003 1.955.301 2.802.818l1.323-1.322V8.78l-.86.86a.377.377 0 01-.53 0 .375.375 0 010-.53l1.39-1.391V6.53l-.86.86a.377.377 0 01-.53 0 .375.375 0 010-.53l1.498-1.5a.372.372 0 01.531 0l1.5 1.5a.375.375 0 01-.531.53l-.86-.86v1.19l1.39 1.39a.375.375 0 01-.53.53l-.86-.86v1.19l1.39 1.39a.375.375 0 01-.53.53l-.86-.86v2.263c.792 1.163 1.317 2.609 1.459 4.197l.157-.15a.375.375 0 01.53.012zm-6.646-2.465v3.099h2.575l-2.575-3.1zm-.75 3.099v-3.1l-2.576 3.1h2.576zm4.5-6.956l-.697.696c.245.194.477.405.697.637V11.03zm-4.131.195c-3.005.003-5.46 3.003-5.616 6.76H7.71l3.637-4.376c.008-.01.019-.014.027-.022.008-.008.013-.02.022-.027.011-.009.024-.011.035-.019a.382.382 0 01.134-.055.36.36 0 01.276.056c.01.008.024.01.035.019.009.007.013.019.022.027.008.008.02.013.027.022l3.637 4.376h1.684c-.155-3.758-2.61-6.758-5.616-6.761z"
}, null, -1), z = /* @__PURE__ */ l({
  name: "ExperiencesCamping",
  __name: "experiences-camping",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (a, d) => (t(), o(s, r(c(e.props)), {
      default: n(() => [p(a.$slots, "default"), i]),
      _: 3
    }, 16));
  }
});
export {
  z as default
};
